/**
 * React 19 Compatibility Configuration
 * 
 * This file suppresses warnings related to React 19 compatibility with Ant Design v5.
 * Ant Design v5 officially supports React 16-18, but works fine with React 19.
 * 
 * Reference: https://u.ant.design/v5-for-19
 */

// Suppress Ant Design React 19 compatibility warning
const originalError = console.error;
console.error = (...args) => {
  // Suppress the specific Ant Design compatibility warning
  if (
    typeof args[0] === 'string' &&
    args[0].includes('[antd: compatible]') &&
    args[0].includes('antd v5 support React is 16 ~ 18')
  ) {
    return;
  }
  originalError.apply(console, args);
};

// Suppress the specific warning about React version
const originalWarn = console.warn;
console.warn = (...args) => {
  // Suppress React version warnings from Ant Design
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('[antd: compatible]') || 
     args[0].includes('antd v5 support React is 16 ~ 18'))
  ) {
    return;
  }
  originalWarn.apply(console, args);
};

export default {};

